import _ from 'lodash';

import { DateTime } from 'luxon';

// https://www.npmjs.com/package/zustand
// https://github.com/pmndrs/zustand/wiki/Splitting-the-store-into-separate-slices
// https://github.com/pmndrs/zustand/wiki/Flux-inspired-practice
// https://github.com/pmndrs/zustand/wiki/Gotchas
// https://github.com/pmndrs/zustand/wiki/3rd-Party-Libraries
// https://github.com/pmndrs/zustand/wiki/Practice-with-no-store-actions
// https://github.com/pmndrs/zustand/wiki/Updating-nested-state-object-values
import create from "zustand";

import version from "modules/version";

// Install React Developer Tools and Redux Developer tools for a better experience.
// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
// https://github.com/zalmoxisus/redux-devtools-extension#usage
// import { devtools } from "zustand/middleware";
// import { combine, devtools, shallow, redux, persist } from "zustand/middleware";

// const selectedDriverId = useGlobalStore(state => state.selectedDriverId)
// const setSelectedDriverId = useGlobalStore(state => state.setSelectedDriverId)
// <button onClick={setSelectedDriverId}>one up</button>
// import shallow from 'zustand/shallow'
// Object pick, re-renders the component when either state.selectedDriverId or state.selectedDeviceId change
// const { selectedDriverId, selectedDeviceId } = useGlobalStore(state => ({ selectedDriverId: state.selectedDriverId, selectedDeviceId: state.selectedDeviceId }), shallow)
// Array pick, re-renders the component when either state.selectedDriverId or state.selectedDeviceId change
// const [selectedDriverId, selectedDeviceId] = useGlobalStore(state => [state.selectedDriverId, state.selectedDeviceId], shallow)
// Mapped picks, re-renders the component when state.treats changes in order, count or keys
// const treats = useGlobalStore(state => Object.keys(state.treats), shallow)
// For more control over re-rendering, you may provide any custom equality function.
// const treats = useGlobalStore(
//   state => state.treats,
//   (oldTreats, newTreats) => compare(oldTreats, newTreats)
// )
// const treat = useGlobalStore(useCallback(state => state.treats[id], [id]))
// Getting non-reactive fresh state:
// const paw = useGlobalStore.getState().paw
// Listening to all changes, fires synchronously on every change:
// const unsub1 = useGlobalStore.subscribe(console.log)
// Updating state, will trigger listeners:
// useGlobalStore.setState({ paw: false })
// Unsubscribe listeners:
// unsub1()
// Destroying the store (removing all listeners):
// useGlobalStore.destroy()
// import { subscribeWithSelector } from 'zustand/middleware'
// const useGlobalStore = create(subscribeWithSelector(() => ({ paw: true, snout: true, fur: true })))
// Listening to selected changes, in this case when "paw" changes
// const unsub2 = useGlobalStore.subscribe(state => state.paw, console.log)
// Subscribe also exposes the previous value
// const unsub3 = useGlobalStore.subscribe(state => state.paw, (paw, previousPaw) => console.log(paw, previousPaw))
// Subscribe also supports an optional equality function
// const unsub4 = useGlobalStore.subscribe(state => [state.paw, state.fur], console.log, { equalityFn: shallow })
// Subscribe and fire immediately
// const unsub5 = useGlobalStore.subscribe(state => state.paw, console.log, { fireImmediately: true })

export const DEFAULT_EMPTY_LIST = [];

// During development, we often make changes to the hooks specified in
// useGlobalStore.js. By moving the store in its own file, we keep it safe from
// hot-reload that re-instantiates the store.
export default create(
// export default create(devtools(
  () => ({
    // https://trello.com/c/0IZ4Gjdx/296-update-breadcrumbs-with-human-readable-identifiers
    breadcrumbs: {},
    // navBar, filterMenu, etc.
    focusLeft: null,
    liveStatus: {
      color: 'white',
      tooltip: 'Unavailable',
      state: '',
      status: 'offline',
      connectionStatus: null,
      reconnecting: false,
      connected: false,
    },
    // productVersion: process?.env?.REACT_APP_VERSION ?? process?.env?.REACT_APP_PRODUCT_VERSION ?? 'vX.Y.Z',
    productVersion: version.version,
    productConfiguration: process?.env?.REACT_APP_PRODUCT_CONFIGURATION ?? 'master',
    // productReleaseDate: process?.env?.REACT_APP_PRODUCT_DATE ?? `${DateTime.now()}`,
    productReleaseDate: version.date,
    // productCopyright: 'Copyright (c) Fifth Dimension Technologies 2021',
    // productCopyright: 'Copyright © Fifth Dimension Technologies 2021',
    showAbout: false,
    // todo: update liveId with uuid/random to prevent collisions
    // liveId: `web-app-${Date.now()}`,
    liveId: `web-app-${_.padStart(_.random(99), 3, '0')}`,
    selectedDevice: {
      id: null,
      serialNumber: null,
    },
    selectedEvent: {
      id: null,
      data: null,
      // focus will cause the UI to focus on the event, via side panel or
      // whatever the UI decides.
      focus: false,
      index: null,
    },
    selectedDriver: {
      id: null,
    },
    selectedTrip: {
      id: null,
      // focus will cause the UI to focus on the trip, via side panel or
      // whatever the UI decides.
      focus: false,
    },
    selectedVehicle: {
      id: null,
    },
    selectedUser: {
      id: null,
    },

    // liveDeviceStatusMap is a map of devices to their location markers
    // _.set(liveDeviceStatusMap, deviceId, location)
    // _.unset(liveDeviceStatusMap, deviceId)
    liveDeviceStatusMap: {},
    liveDeviceStatusList: [],
    liveDeviceTripList: [],

    // The mqtt messages accepted (i.e. event stream).
    // See addMessage, clearMessages, useMessages, etc.
    // This list only contains the last x amount of accepted messages
    // This is primarily useful for displaying a notification feed of live events
    // Imagine a table view that lists the last x live messages 
    // See deviceMessageList for a list that shows all messages for a specific device
    // messageList: [],

    // messageIndex could have been a Set, but an object offers the same type of
    // guarantees without having to include more middleware.
    // messageIndex is a method to check whether a mqtt message has already been received
    // it is an ordered "set" of unique message identifiers
    // refreshing the page loses this index
    // NOTE: This messageIndex can become really big. Since it is only used to
    // detect duplicate gps positions, we may want to implement a different
    // mechanism to detect/prevent/accept duplicates.
    // messageIndex: {},

    // The status of the currently selected live device.
    deviceStatus: null,

    // This ensures that we can prevent recalculations when we return a default empty list.
    defaultEmptyList: DEFAULT_EMPTY_LIST,

  }));
  // })));
